import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

//MaterialUI Imports
import {
    Button,
    CardContent,
    CardHeader,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography,
    Stack,
    Alert,
    Snackbar,
    Pagination,
    TextField,
    InputAdornment,
    Grid,
    Select,
    MenuItem,
    Card
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

//Icon Imports
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SellIcon from '@mui/icons-material/Sell';
import ArticleIcon from '@mui/icons-material/Article';

//Project Imports
import MainCard from 'ui-component/cards/MainCard';
import useSalesRecordService from 'services/useSalesRecordService';
import SalesRecodsForm from './SalesRecodsForm';
import NoResults from 'assets/images/noresults.png';

const SalesRecords = () => {
    //Constants
    const theme = useTheme();
    const navigate = useNavigate();
    const { deleteSalesRecord, getSalesRecord } = useSalesRecordService();
    const skip = 0;
    const pageSize = 50;

    //States
    const [salesDetails, setSalesDetails] = useState([]);
    const [selectedSalesRecord, setSelectedSalesRecord] = useState();

    const [saleCount, setSaleCount] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [currentSkipValue, setCurrentSkipValue] = useState(0);

    const [openForm, setOpenForm] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [isError, setIsError] = useState();
    const [openToast, setOpenToast] = useState(false);

    //Methods
    const handleCancel = () => {
        setOpenForm(false);
    };

    const handleSave = () => {
        getSalesRecordList();
    };

    const handleCloseToast = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenToast(false);
    };

    const getSalesRecordList = () => {
        getSalesRecord(currentSkipValue, pageSize)
            .then((response) => {
                console.log(response);
                if (response.status == 200) {
                    setSaleCount(response.data.count);
                    setSalesDetails(response.data.list);
                }
            })
            .catch((error) => {
                setIsError(error.message);
            });
    };

    const handleDelete = () => {
        deleteSalesRecord(selectedSalesRecord.id)
            .then((response) => {
                getSalesRecordList();
                setOpenToast(true);
                setOpenDeleteDialog(false);
            })
            .catch((error) => {
                console.log(error);
                setOpenDeleteDialog(false);
            });
    };

    //UseEffects

    useEffect(() => {
        setSalesDetails(undefined);
        getSalesRecordList();
    }, []);

    return (
        <>
            <MainCard>
                <CardHeader
                    avatar={<SellIcon color="primary" />}
                    title="Sales List"
                    sx={{ padding: 0 }}
                    action={
                        <Grid container>
                            <Grid item sx={{ display: { xs: 'none', sm: 'block', md: 'block', xl: 'block' } }}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    startIcon={<AddIcon />}
                                    align="right"
                                    onClick={() => {
                                        setSelectedSalesRecord({
                                            id: 0,
                                            date: new Date().toISOString().split('T')[0],
                                            soldBy: '',
                                            recordedBy: 0,
                                            note: ''
                                        });
                                        setOpenForm(true);
                                    }}
                                >
                                    Add New Record
                                </Button>
                            </Grid>
                        </Grid>
                    }
                />

                <Divider sx={{ marginY: 3 }} />

                <Grid item align="right" sx={{ display: { xs: 'block', sm: 'none', md: 'none', xl: 'none' } }}>
                    <Button
                        variant="contained"
                        color="secondary"
                        startIcon={<AddIcon />}
                        align="right"
                        onClick={() => {
                            setSelectedSalesRecord({
                                id: 0,
                                date: new Date().toISOString().split('T')[0],
                                soldBy: '',
                                recordedBy: 0,
                                note: ''
                            });
                            setOpenForm(true);
                        }}
                    >
                        Add New Record
                    </Button>
                </Grid>

                {salesDetails != undefined && (
                    <>
                        {saleCount != undefined && saleCount != 0 ? (
                            <Pagination
                                count={Math.ceil(saleCount / pageSize)}
                                variant="outlined"
                                shape="rounded"
                                showFirstButton
                                showLastButton
                                color="primary"
                                sx={{ marginY: 2 }}
                                onChange={(event, page) => {
                                    setCurrentSkipValue((page - 1) * pageSize);
                                    setCurrentPage(page);
                                }}
                            />
                        ) : null}
                    </>
                )}

                {salesDetails != undefined ? (
                    <>
                        {salesDetails.length === 0 ? (
                            <Grid align="center" sx={{ mt: 5, mb: 5 }}>
                                <img src={NoResults} alt="No Result" width="150px" />
                                <Typography variant="h4" fontWeight={100}>
                                    There are no sales record found
                                </Typography>
                            </Grid>
                        ) : (
                            <>
                                <Grid item sm={12} md={12} lg={12} sx={{ display: { xs: 'none', sm: 'block', md: 'block', xl: 'block' } }}>
                                    <TableContainer>
                                        <Table
                                            sx={{
                                                border: 'solid',
                                                borderWidth: 1,
                                                borderColor: 'divider'
                                            }}
                                        >
                                            <TableHead sx={{ backgroundColor: theme.palette.primary.light }}>
                                                <TableCell sx={{ width: 70 }}>
                                                    <Typography variant="h5">Sr.No.</Typography>{' '}
                                                </TableCell>
                                                <TableCell sx={{ width: 150 }}>
                                                    <Typography variant="h5">Record Number</Typography>{' '}
                                                </TableCell>
                                                <TableCell sx={{ width: 120 }}>
                                                    <Typography variant="h5">Date</Typography>
                                                </TableCell>
                                                <TableCell sx={{ width: 190 }}>
                                                    <Typography variant="h5">Sold By</Typography>
                                                </TableCell>
                                                <TableCell sx={{ width: 190 }}>
                                                    <Typography variant="h5">Recorded By</Typography>
                                                </TableCell>

                                                <TableCell></TableCell>
                                            </TableHead>
                                            <TableBody>
                                                {salesDetails?.map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell component="th" scope="row">
                                                            {index + 1}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {row.recordFYStart}
                                                            {row.recordFYEnd.toString().slice(-2)}
                                                            {row.recordNumber.toString().padStart(6, '0')}
                                                        </TableCell>
                                                        <TableCell align="left">{new Date(row.date).toLocaleDateString('hi-IN')}</TableCell>
                                                        <TableCell align="left">{row.soldByName}</TableCell>
                                                        <TableCell align="left">{row.recordedByName}</TableCell>
                                                        <TableCell align="right">
                                                            <Tooltip title="Sales details">
                                                                <IconButton
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        navigate('/sales-details?Id=' + row.id);
                                                                    }}
                                                                >
                                                                    <ArticleIcon fontSize="inherit" />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="Edit Sales Record details">
                                                                <IconButton
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        setSelectedSalesRecord(row);
                                                                        setOpenForm(true);
                                                                    }}
                                                                >
                                                                    <EditIcon fontSize="inherit" />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="Delete Sales Record">
                                                                <IconButton
                                                                    color="error"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        setSelectedSalesRecord(row);
                                                                        setOpenDeleteDialog(true);
                                                                    }}
                                                                >
                                                                    <DeleteIcon fontSize="inherit" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                                {salesDetails.map((row, index) => (
                                    <Grid key={index} item xs={12} sx={{ display: { xs: 'block', sm: 'none', md: 'none', xl: 'none' } }}>
                                        <Card sx={{ p: 2 }} variant="outlined" key={index}>
                                            <Stack justifyContent="space-between" direction="row" alignItems="center" spacing={2}>
                                                <Typography variant="h5">Record Number:</Typography>
                                                <Typography>{row.recordNumber}</Typography>
                                            </Stack>
                                            <Stack justifyContent="space-between" direction="row" sx={{ mt: 2 }}>
                                                <Typography variant="h5">Date:</Typography>
                                                <Typography>{new Date(row.date).toLocaleDateString('hi-IN')}</Typography>
                                            </Stack>
                                            <Stack justifyContent="space-between" direction="row" sx={{ mt: 2 }}>
                                                <Typography variant="h5">Sold By:</Typography>
                                                <Typography>{row.soldByName}</Typography>
                                            </Stack>
                                            <Stack justifyContent="space-between" direction="row" sx={{ mt: 2 }}>
                                                <Typography variant="h5">Recorded By:</Typography>
                                                <Typography>{row.recordedBy}</Typography>
                                            </Stack>
                                            <Stack justifyContent="space-between" direction="row" sx={{ mt: 2 }}>
                                                <Typography variant="h5">Note:</Typography>
                                                <Typography>{row.note}</Typography>
                                            </Stack>
                                            <Divider sx={{ mt: 1 }} />
                                            <Stack justifyContent="flex-end" direction="row" alignItems="right" sx={{ mt: 2 }}>
                                                <Tooltip title="Sales details">
                                                    <IconButton
                                                        variant="outlined"
                                                        color="primary"
                                                        size="small"
                                                        onClick={() => {
                                                            navigate('/sales-details?Id=' + row.id);
                                                        }}
                                                    >
                                                        <ArticleIcon fontSize="inherit" />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Edit Sales Record details">
                                                    <IconButton
                                                        variant="outlined"
                                                        color="primary"
                                                        size="small"
                                                        onClick={() => {
                                                            setSelectedSalesRecord(row);
                                                            setOpenForm(true);
                                                        }}
                                                    >
                                                        <EditIcon fontSize="inherit" />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Delete Sales Record">
                                                    <IconButton
                                                        color="error"
                                                        size="small"
                                                        onClick={() => {
                                                            setSelectedSalesRecord(row);
                                                            setOpenDeleteDialog(true);
                                                        }}
                                                    >
                                                        <DeleteIcon fontSize="inherit" />
                                                    </IconButton>
                                                </Tooltip>
                                            </Stack>
                                        </Card>
                                    </Grid>
                                ))}
                            </>
                        )}
                    </>
                ) : (
                    <Stack direction="column" justifyContent="Center" alignItems="center" spacing={2} sx={{ marginY: 3 }}>
                        <Typography variant="h4" textAlign="center">
                            Getting Sales Record List...
                        </Typography>
                        <CircularProgress />
                    </Stack>
                )}
            </MainCard>
            <Dialog open={openForm} onClose={handleCancel} fullWidth maxWidth="sm">
                <DialogContent>
                    <SalesRecodsForm onSave={handleSave} onCancel={handleCancel} selectedSalesRecord={selectedSalesRecord} />
                </DialogContent>
            </Dialog>

            <Dialog
                open={openDeleteDialog}
                onClose={() => {
                    setOpenDeleteDialog(false);
                }}
                fullWidth
            >
                <DialogTitle>
                    <Typography variant="h4" color={theme.palette.secondary.dark}>
                        Delete Sales Record Details
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography variant="h5" color={theme.palette.error}>
                        Are you sure you want to delete this sales details ?
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={() => {
                            handleDelete();
                        }}
                        variant="contained"
                    >
                        Yes
                    </Button>
                    <Button
                        onClick={() => {
                            setOpenDeleteDialog(false);
                        }}
                        variant="outlined"
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar open={openToast} autoHideDuration={6000} onClose={handleCloseToast}>
                <Alert onClose={handleCloseToast} severity="success" sx={{ width: '100%', backgroundColor: theme.palette.success.main }}>
                    <Typography sx={{ color: theme.palette.grey[50] }}>Sales Record deleted succesfully!!</Typography>
                </Alert>
            </Snackbar>
        </>
    );
};

export default SalesRecords;
